// extracted by mini-css-extract-plugin
module.exports = {"suffixIcon":"talent-profile-print-selection_suffixIcon__1a2kk"};